import { COLORS } from '@constants';
import { Icon } from '@ui';
import { Upload } from 'antd';
import styled, { css, keyframes } from 'styled-components';

const rotateAnimation = keyframes`
    0% { transform: rotate(360deg) }
    100% { transform: rotate(0deg) }
`;

export const Container = styled.div`
    width: 100%;
    background: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StyledStatusWrapper = styled.div`
    width: 100%;
    padding: 48px 24px;
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
    background: ${COLORS.$white};
    min-height: 176px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ $error }) =>
        $error
            ? css`
                  border-color: ${COLORS.$error};
              `
            : ''}
`;

export const StyledIcon = styled(Icon)`
    ${({ $pending }) =>
        $pending
            ? css`
                  animation-name: ${rotateAnimation};
                  animation-duration: 1s;
                  animation-iteration-count: infinite;
              `
            : ''}
`;

export const StyledUpload = styled(Upload)`
    ${({ $pending }) =>
        $pending
            ? css`
                  touch-action: none;
                  pointer-events: none;
              `
            : ''}
`;
